exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 600px;\r\n  width: 840px;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.label-col-1 {\r\n  flex: 0 0 100px;\r\n  min-width: 100px;\r\n  text-align: right;\r\n  padding-right: 10px;\r\n}\r\n\r\n.label-col-2 {\r\n  flex: 0 0 90px;\r\n  min-width: 90px;\r\n  text-align: right;\r\n  padding-right: 10px;\r\n}\r\n\r\n.label-col-3 {\r\n  flex: 0 0 115px;\r\n  min-width: 115px;\r\n  text-align: right;\r\n  padding-right: 10px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/marketing/mailing/dialogs/mailing-add.component.css
// module id = 2532
// module chunks = 1